//eslint-disable-next-line
let config = {};
if (process.env.NODE_ENV == 'development') {
    config = {
        "API_URL": "https://t1.equipweb.biz/edgecafetraining/Setup/core",
        "API_URL_OLD": `http://localhost:2727/WebAPI`,
        "WEB_URL": "https://t1.equipweb.biz/edgecafetraining/Setup",
        "BASE_URL": "",
        "BASE_PATH": 'equip-develop',
        "TIME_INTERVAL": "",
        "WEB_VERSION": "v1.0.0.0",
        "DEFAULT_IMAGE": "/img/default-img.png",
    }
}
else {

    let url = window.location.pathname;

    let idx = url.toLowerCase().indexOf("/setup");
    let useSecondLevelPath = true;
    if (idx <= 0)
        useSecondLevelPath = false;

    let urlPath = window.location.pathname.split('/');
    let basePath = urlPath[1];

    if (useSecondLevelPath && urlPath.length > 1)
        basePath = basePath + '/' + window.location.pathname.split('/')[2];
    console.log("useSecondLevelPath:" + useSecondLevelPath);

    config = {
        "WEB_URL": `${window.location.origin}/${basePath}`,
        "API_URL": `${window.location.origin}/${basePath}/core`,
        "API_URL_OLD": `${window.location.origin}/${basePath}/WebAPI`,
        "BASE_URL": `${basePath}/new`,
        "BASE_PATH": basePath.toLocaleLowerCase(),
        "TIME_INTERVAL": "",
        "WEB_VERSION": "v1.0.0.0",
        "DEFAULT_IMAGE": `${window.location.origin}/${basePath}/new/img/default-img.png`,
    }
}

export default config